import Table from '@tiptap/extension-table'

const CustomTable = Table.extend({
  addStorage() {
    return {
      isUnset: false,
    }
  },

  addAttributes() {
    return {
      ...this.parent?.(),

      unset: {
        default: false,
        parseHTML: (element) => {
          const isUnset = !!element.getAttribute('unset')
          this.storage.isUnset = isUnset
          return isUnset
        },
        renderHTML: (attributes) => {
          const isUnset = !!attributes.unset
          this.storage.isUnset = isUnset

          // if unset, add attributes
          if (isUnset) {
            return {
              unset: true,
              class: 'unset',
            }
          }

          // if not unset, clear attributes
          return {}
        },
      },
    }
  },

  // @todo implementing resizable breaks attributes (unset) for some reason
  // addOptions() {
  // 	return {
  // 		...this.parent?.(),
  // 		resizable: true
  // 	}
  // },
})

export { CustomTable }
export default CustomTable
